/*
  Timeline line height controller

  - By default, .timeline-step-line has height: 100%
  - If a marker element is present (either [data-last-step] attribute
    or the legacy .data-last-step class), the line should end at that
    marker, aligned to the marker's vertical center.

  This script recalculates heights on load, resize, orientation change,
  and when collapsible content toggles.
*/

(function () {
    'use strict';

    /**
     * @template {Node} T
     * @param {ArrayLike<T> | NodeListOf<T>} nodeList
     * @returns {T[]}
     */
    function toArray(nodeList) {
        return Array.prototype.slice.call(nodeList || []);
    }

    /**
     * @param {Element} step
     * @returns {Element | null}
     */
    function findStopElement(step) {
        // Support both attribute and legacy class-based marker
        return (
            step.querySelector('[data-last-step]') || step.querySelector('.data-last-step')
        );
    }

    /**
     * @param {Element} step
     */
    function updateStep(step) {
        /** @type {HTMLElement | null} */
        const line = step.querySelector('.timeline-step-line');
        if (!line) return;

        const stopEl = findStopElement(step);
        if (!stopEl) {
            line.style.height = '100%';
            return;
        }

        // Measure from top of step to the vertical center of the stop element
        const stepRect = step.getBoundingClientRect();
        const stopRect = stopEl.getBoundingClientRect();

        const heightPx = Math.max(0, (stopRect.top - stepRect.top) + stopRect.height / 2);
        line.style.height = Math.round(heightPx) + 'px';
    }

    function updateAll() {
        toArray(document.querySelectorAll('.timeline-step')).forEach(updateStep);
    }

    // rAF-scheduled updates to avoid layout thrash
    let scheduled = false;
    function scheduleUpdate() {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
            scheduled = false;
            updateAll();
        });
    }

    // Initial and responsive updates
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleUpdate);
    } else {
        scheduleUpdate();
    }

    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('orientationchange', scheduleUpdate);

    // Recalculate when collapsible content toggles (common in this timeline)
    document.addEventListener('click', function (event) {
        /** @type {Element | null} */
        const target = event.target instanceof Element ? event.target : null;
        const toggle = target && target.closest ? target.closest('[data-collapsible-toggle]') : null;
        if (toggle) {
            // defer to allow layout changes/animations to settle
            setTimeout(scheduleUpdate, 50);
            setTimeout(scheduleUpdate, 250);
        }
    });

    // Observe size changes within steps for dynamic content
    if (window.ResizeObserver) {
        const ro = new ResizeObserver(function () {
            scheduleUpdate();
        });
        toArray(document.querySelectorAll('.timeline-step')).forEach(
            /** @param {Element} el */
            function (el) {
                ro.observe(el);
            });
    }
})();


